import config from '@/assets/js/config'
import toast from './toast';
export default {
    /**
     * 信息
     * @param {日志内容} msg 
     */
    i(msg){
        if(config.debug) {
            console.log('[info] '+(typeof msg == 'string' ? msg : JSON.stringify(msg)));
            if(config.toastShowLog){
                toast.show('[info] '+(typeof msg == 'string' ? msg : JSON.stringify(msg)));
            }
        }
    },
    /**
     * 警告
     * @param {日志内容} msg 
     */
    w(msg){
        console.log('[warn] '+msg);
        if(config.debug && config.toastShowLog) {
            toast.show('[warn] '+(typeof msg == 'string' ? msg : JSON.stringify(msg)));
        }
    },
    /**
     * 错误
     * @param {日志内容} msg 
     */
    e(msg){
        console.log('[error] '+msg);
        if(config.toastShowLog) {
            toast.show('[error] '+(typeof msg == 'string' ? msg : JSON.stringify(msg)));
        }
    },
    /**
     * 调试
     * @param {日志内容} msg 
     */
    d(msg){
        if(config.debug) {
            console.log('[debug] '+(typeof msg == 'string' ? msg : JSON.stringify(msg)));
            if(config.toastShowLog) {
                toast.show('[error] '+(typeof msg == 'string' ? msg : JSON.stringify(msg)));
            }
        }
    }
}
